/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Matrix_LeadInputs */

const en_hub_matrix_lead = /** @type {(inputs: Hub_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export writes the target tool's real layout, not a generic dump. Import reads it back into features, tasks and acceptance criteria.`)
};

const id_hub_matrix_lead = /** @type {(inputs: Hub_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor menulis tata letak asli alat tujuan, bukan buangan generik. Impor membacanya kembali menjadi fitur, task, dan kriteria penerimaan.`)
};

/**
* | output |
* | --- |
* | "Export writes the target tool's real layout, not a generic dump. Import reads it back into features, tasks and acceptance criteria." |
*
* @param {Hub_Matrix_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_matrix_lead = /** @type {((inputs?: Hub_Matrix_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Matrix_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_matrix_lead(inputs)
	return en_hub_matrix_lead(inputs)
});